// правила валидации полей формы пользователя (регистрация и редактирование профиля)
export const userFormRules = {
  required: (v) => (v !== '' && v !== undefined && v !== null) || 'Заполните поле',
  email: (v) => v === '' || /.+@.+\..+/.test(v) || 'Введите корректный E-mail',
}

export const phoneRule = (v) => {
  const digits = String(v ?? '').replace(/\D/g, '')

  return !digits || digits.length === 11 || 'Введите номер телефона полностью'
}

export const birthDateRule = (v) => {
  if (!v) return true

  if (!/^\d{2}\.\d{2}\.\d{4}$/.test(v)) return 'Введите дату в формате дд.мм.гггг'

  const [day, month, year] = v.split('.').map(Number)
  const date = new Date(year, month - 1, day)

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return 'Такой даты не существует'
  }

  if (date > new Date()) return 'Дата не может быть в будущем'

  return true
}

// дд.мм.гггг -> YYYY-MM-DD (формат, который принимает API)
export const toIsoBirthDate = (v) => {
  if (!v) return null

  const [day, month, year] = v.split('.')

  return `${year}-${month}-${day}`
}

// YYYY-MM-DD -> дд.мм.гггг (для отображения в форме)
export const fromIsoBirthDate = (v) => {
  if (!v) return ''

  const match = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/)

  if (!match) return String(v)

  return `${match[3]}.${match[2]}.${match[1]}`
}

export const genderInString = (gender) => {
  if (gender === 'male') return 'Мужской'
  if (gender === 'female') return 'Женский'

  return ''
}

const emptyToNull = (v) => v || null

// userInfo из стора -> поля UserForm
export const userInfoToForm = (userInfo) => ({
  lastname: userInfo?.lastname || '',
  firstname: userInfo?.firstname || '',
  middlename: userInfo?.middlename || '',
  gender: userInfo?.gender || null,
  birthDate: fromIsoBirthDate(userInfo?.birthday),
  email: userInfo?.email || '',
  phone: userInfo?.phone || '',
  region: userInfo?.region || '',
  city: userInfo?.city || '',
  organization: userInfo?.work_company || '',
  position: userInfo?.work_position || '',
  agreement: false,
})

// поля UserForm -> payload для PATCH /v3/users/profile (email бэкенд игнорирует)
export const formToProfilePatch = (form) => ({
  lastname: form.lastname,
  firstname: form.firstname,
  middlename: emptyToNull(form.middlename),
  gender: form.gender,
  birthDate: toIsoBirthDate(form.birthDate),
  email: form.email,
  phone: emptyToNull(form.phone),
  region: emptyToNull(form.region),
  city: emptyToNull(form.city),
  organization: emptyToNull(form.organization),
  position: emptyToNull(form.position),
})
